export function guessFormat(word: string) {
    return word
      .toLowerCase()
      .replace('—', '-')
      .replace(/[^a-z0-9\s+/,\.\+\-\{\}\:]'/g, '')
      .trim()
  }


export function limitArrayLength(arr: string[]) {
  if (arr.length< 5) {
    return arr
  }
  return arr.filter((item, index) => index !== 0)
}

export const convertNameToGuessArray = (name:string): string[] => {
  const out: string[] = []

  name.split('').forEach(letter => {
    if (letter.toLowerCase().match(/^[0-9a-z]+$/)) out.push('')
  })

  return out
}

export const isCommander = (type_line: string, oracle_text: string): boolean => {
  if ( (type_line.includes('Legendary') && type_line.includes('Creature')) || oracle_text.includes("can be your commander") ) {
    return true
  } else {
    return false
  }
}